// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// ==============================|| FOOTER - DASHBOARD (BONESIDE) ||============================== //

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between', p: '24px 16px 0px', mt: 'auto' }}
    >
      <Typography variant="caption" color="text.secondary">
        &copy; {year}{' '}
        <Link
          href="https://boneside.com.br"
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
          sx={{ fontWeight: 600 }}
        >
          Boneside
        </Link>{' '}
        · Todos os direitos reservados
      </Typography>
      <Stack direction="row" sx={{ gap: 2, alignItems: 'center' }}>
        <Typography variant="caption" color="text.secondary">
          Rocky · ERP Boneside
        </Typography>
        <Link
          href="https://boneside.com.br"
          target="_blank"
          rel="noopener noreferrer"
          variant="caption"
          color="text.primary"
          underline="hover"
        >
          boneside.com.br
        </Link>
      </Stack>
    </Stack>
  );
}
